<template>
  <div>
    <CRow class="w-100 d-flex justify-content-between align-items-center">
      <CCol>
        <h4>Hey {{ familyName }}! 👋</h4>
      </CCol>
      <CCol class="d-flex justify-content-end p-0 m-0">
        <TourStartButton />
      </CCol>
    </CRow>
    <DashboardFamily v-if="!askZip" />
    <!--<DashboardAddressModal v-if="askZip" />-->
    <AddressesModal
      :show="askZip"
      :title="$t('family.dashboard.zip_modal.title')"
      :desc="$t('family.dashboard.zip_modal.text')"
    />
  </div>
</template>

<script>
import DashboardFamily from "./DashboardFamily.vue";
import DashboardFamilyMarket from "./DashboardFamilyMarket.vue";
//import DashboardAddressModal from "./DashboardAddressModal.vue";
import AddressesModal from "./settings/AddressesModal.vue";
import TourStartButton from "./partials/TourStartButton.vue";

export default {
  data() {
    return {};
  },
  computed: {
    askZip() {
      if (this.$store.state.connections.current.zip_code) {
        return false;
      }
      return true;
    },
    showMarket() {
      return this.$store.state.role.market__id > 0;
    },
    showProducer() {
      return this.$store.state.role.producer__id > 0;
    },
    showIsland() {
      return this.$store.state.role.island__id > 0;
    },
    familyName() {
      return this.$store.state.connections.current.family.name;
    },
  },
  components: {
    DashboardFamily,
    DashboardFamilyMarket,
    AddressesModal,
    TourStartButton,
  },
};
</script>
